import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaOperadoraDepositos', {
    template: template,
    controller: NominaOperadoraDepositosComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      total: '<',
      onChange: '&',
    },
  })

function NominaOperadoraDepositosComponent(NominaOperadoraDepositos) {
  let $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.actualizar = actualizar
  $ctrl.agregar = agregar
  $ctrl.eliminar = eliminar

  function $onInit() {
    $ctrl.indice = null
    $ctrl.promise = NominaOperadoraDepositos.get($ctrl.idEmpresa, $ctrl.idNomina)
      .then(function (response) {
        $ctrl.data = response.data
        totalizar()
      })
  }

  function actualizar(item, data) {
    angular.extend(item, data)
    $ctrl.indice = null
    totalizar()
    $ctrl.onChange({$event: {data: {depositado: $ctrl.depositado}}})
  }

  function agregar(item) {
    $ctrl.data.push(item)
    totalizar()
    $ctrl.onChange({$event: {data: {depositado: $ctrl.depositado}}})
  }

  function eliminar(item) {
    $ctrl.data.splice($ctrl.data.indexOf(item), 1)
    $ctrl.indice = null
    totalizar()
    $ctrl.onChange({$event: {data: {depositado: $ctrl.depositado}}})
  }

  function totalizar() {
    $ctrl.depositado = $ctrl.data.reduce(function (depositado, item) {
      return parseFloat((depositado + item.importe).toFixed(2))
    }, 0)

    $ctrl.pendiente = Math.max(0, $ctrl.total - $ctrl.depositado)
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/operadora/depositos/component.js